import type { PublicationCode } from './types'
import { ELIZA_PUBLICATION_CODES, SUNWEB_PUBLICATION_CODES, WINTER_ONLY_PUBLICATION_CODES } from './constants'

export function isSunwebSummerPublicationCode(code: PublicationCode): boolean {
  return (SUNWEB_PUBLICATION_CODES.summer as readonly unknown[]).includes(code)
}

export function isSummerPublicationCode(code: PublicationCode): boolean {
  return isSunwebSummerPublicationCode(code) || isElizaPublicationCode(code)
}

export function isSunwebWinterPublicationCode(code: PublicationCode): boolean {
  return (SUNWEB_PUBLICATION_CODES.winter as readonly PublicationCode[]).includes(code)
}

export function isElizaPublicationCode(code: PublicationCode): boolean {
  return (ELIZA_PUBLICATION_CODES as readonly PublicationCode[]).includes(code)
}

export function isWinterOnlyPublicationCode(code: PublicationCode): boolean {
  return (WINTER_ONLY_PUBLICATION_CODES as readonly PublicationCode[]).includes(code)
}
